<template>
  <section class="relative bg-black overflow-hidden px-6 lg:px-16 xl:px-40 py-20 md:py-28">
    <img
      :src="motionBgUrl"
      alt=""
      aria-hidden="true"
      class="absolute inset-0 w-full h-full object-cover blur-2xl opacity-25 scale-110 pointer-events-none"
    />
    <div class="absolute inset-0 bg-black/30 pointer-events-none" />

    <div class="relative flex flex-col items-center text-center gap-6 max-w-[720px] mx-auto">
      <h2 class="font-display font-semibold text-4xl md:text-[60px] leading-tight text-white !mt-0 !mb-0">
        {{ t(props.titleKey ?? 'home.closingCta.title') }}
      </h2>
      <p class="font-sans text-lg md:text-xl text-[#ededec] !mt-0 !mb-0">
        {{ t(props.bodyKey ?? 'home.closingCta.body') }}
      </p>
      <div class="flex flex-wrap items-center justify-center gap-4 mt-2">
        <RouterLink
          :to="{ name: 'bookMeeting' }"
          class="inline-flex items-center gap-4 rounded bg-primary hover:bg-primary-dark text-white hover:text-white text-[18px] px-4 py-2.5 transition-colors"
        >
          <span>{{ t('home.closingCta.bookAppointment') }}</span>
          <VaIcon name="event" :size="24" />
        </RouterLink>
        <RouterLink
          :to="{ name: 'contact' }"
          class="inline-flex items-center gap-4 rounded bg-surface-1 hover:bg-surface-2 text-white hover:text-white text-[18px] px-4 py-2.5 transition-colors"
        >
          <span>{{ t('home.closingCta.contactUs') }}</span>
          <VaIcon name="call" :size="24" />
        </RouterLink>
      </div>
    </div>

    <div
      class="relative mx-auto mt-12 md:mt-16 w-full max-w-[820px] overflow-hidden"
      style="aspect-ratio: 784 / 308;"
    >
      <img
        :src="calendarUrl"
        alt=""
        aria-hidden="true"
        class="absolute top-0 left-0 w-full h-auto drop-shadow-2xl"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { VaIcon } from 'vuestic-ui'
import motionBgUrl from '@/assets/images/closing-cta-bg.webp?url'
import calendarUrl from '@/assets/images/closing-cta-calendar.webp?url'

const props = defineProps<{
  titleKey?: string
  bodyKey?: string
}>()

const { t } = useI18n()
</script>
